import axios from 'axios'
import {
    FETCH_BOLSA,
    APIpath,
    addToast,
    setRedirect
} from '../actions'

const setBolsa = (bolsa) => ({
    type: FETCH_BOLSA,
    bolsa
})

export const fetchBolsa = () => (dispatch) => {
    dispatch(setRedirect(false))
    axios.get(`${APIpath}/bolsa/`)
        .then(function (response) {
            dispatch(setBolsa(response.data))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}

export const createBolsa = (values) => (dispatch) => {
    axios.post(`${APIpath}/bolsa/store`, values)
        .then(function (response) {
            dispatch(setRedirect(true))
            dispatch(addToast('success', 'Elemento creado'))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}

export const updateBolsa = (values) => (dispatch) => {
    axios.post(`${APIpath}/bolsa/update`, values)
        .then(function (response) {
            dispatch(addToast('success', 'Elemento actualizado'))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}

export const updateStatusBolsa = (id) => dispatch => {
    axios.post(`${APIpath}/bolsa/status`, { id })
        .then(function (response) {
            dispatch(addToast('success', 'Elemento actualizado'))
            dispatch(setRedirect(true))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}